import type { QuizQuestion } from '@efdigital/ll-addon-data';
import { type TemplateOnlyComponent } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';

import EditModeToggle from './edit-mode-toggle.gts';
import type { QuestionManager } from './types/question-manager.ts';
import type { EditingMode } from './utils.ts';

const QuestionEditorButtonsInput: TemplateOnlyComponent<{
  Args: {
    question: QuizQuestion;
    index: number;
    isEditing: boolean;
    manager: QuestionManager;
    isEditingMode: (index: number, mode: EditingMode) => boolean;
    setEditingMode: (
      question: QuizQuestion | null,
      index: number,
      mode: EditingMode
    ) => void;
    onRemove: () => void;
  };
}> = <template>
  <div
    class="btn-group bg-primary-subtle shadow-sm question-editor-buttons-container
      {{if @isEditing 'is-editing'}}"
  >
    <EditModeToggle
      @isActive={{@isEditingMode @index "markdown"}}
      @icon="ph:text-align-left"
      @buttonText="Helper Text"
      @onActivate={{fn @setEditingMode @question @index "markdown"}}
      @onDeactivate={{fn @setEditingMode null -1 "inactive"}}
    />

    {{#if @manager.questionComponent}}
      <EditModeToggle
        @isActive={{@isEditingMode @index "question"}}
        @icon={{@manager.editingIcon}}
        @buttonText={{@manager.editingLabel}}
        @onActivate={{fn @setEditingMode @question @index "question"}}
        @onDeactivate={{fn @setEditingMode null -1 "inactive"}}
      />
    {{/if}}

    <button
      aria-label="Remove question"
      class="btn btn-outline-primary rounded-start-0 rounded-top-0 btn-sm px-2 py-1 flex-grow-0 ms-auto d-flex flex-row align-items-center
        {{if @isEditing 'rounded-bottom-0' 'rounded-bottom-1'}}"
      type="button"
      {{on "click" @onRemove}}
    ><iconify-icon inline icon="ph:trash" class="fs-4" /></button>
  </div>
</template>;

export default QuestionEditorButtonsInput;
